import { DateTime } from 'luxon'

import { ArticleCategory, type ParishConfig } from '~/utils/types'

// Declare gtag for Google Analytics
declare const gtag: Function | undefined

const findEpisode = () => {
  const route = useRoute()
  const podcasts = usePodcasts()
  const slug = ref<string>('')

  if (route.params?.slug) slug.value = [...route.params.slug].join('/')

  const { basic: _basic, ...rest } = podcasts.value

  for (const podcast in rest) {
    for (const episode of rest[podcast].items) {
      if (episode.url === slug.value) {
        return episode
      }
    }
  }

  return null
}

const initParishConfig = async () => {
  const runtimeConfig = useRuntimeConfig()
  const parishConfig = useParishConfig()
  const parishLocale = (runtimeConfig.public.parishLocale || '').toLowerCase()
  const configJson = await import(`../config/${parishLocale}/config.json`)

  parishConfig.value = configJson.default as ParishConfig
}

const getGqlPage = async (page: any) =>
  new Promise((resolve, reject) => {
    const route = useRoute()
    const { ToArticle } = useMappers()

    if (!page.length) {
      if (route.path.includes(ArticleCategory.blog)) {
        const episode = findEpisode()
        if (episode) return resolve(ToArticle(episode, true))
      }

      reject('PNF')
    }

    resolve(ToArticle(page[0]))
  })

const pushEvent = (event: string, data: any = undefined) => {
  if (import.meta.server) return

  // Use requestIdleCallback to defer analytics to idle time
  // to avoid blocking the main thread during user interaction
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => {
      if (typeof gtag === 'function') {
        gtag('event', event, data)
      }
      umTrackEvent(event, data)
    })
  } else {
    // Fallback for browsers without requestIdleCallback
    setTimeout(() => {
      if (typeof gtag === 'function') {
        gtag('event', event, data)
      }
      umTrackEvent(event, data)
    }, 0)
  }
}

const isContentOld = (timestamp: string): boolean => {
  if (!timestamp) return true
  return DateTime.now() > DateTime.fromISO(timestamp).plus({ minutes: 30 })
}

export default () => {
  return {
    getGqlPage,
    initParishConfig,
    isContentOld,
    pushEvent,
  }
}
